import React, { Component } from "react";
import { object, func, string } from "prop-types";
import { Modal, DropdownButton, Glyphicon, MenuItem, OverlayTrigger, Popover, Col } from "react-bootstrap";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import moment from "moment";

import rollbar from "../utils/Rollbar";
import { updateVideo, addAlertToVideo } from "../actions";
import config from "../config";
import { getAuthToken } from "../utils/sessionStorage";

import NewAlertForm from "./forms/NewAlertForm";
import ThumbnailsModal from "./modals/ThumbnailsModal";
import ApprovalThumbPreview from "./ApprovalThumbPreview";
import AppropriationTimeModal from "./modals/AppropriationTimeModal";
import VideoConfigModal from "./modals/VideoConfigModal";
import ButtonPlayPause from "./ButtonPlayPause";
import VideoStatusLabel from "./VideoStatusLabel";
import VideoTitleEditable from "./VideoTitleEditable";
import VideoBotConfigModal from "./modals/VideoBotConfigModal";
import RefishingModal from "./modals/RefishingModal";
import DataExtractionModal from "./modals/DataExtractionModal";
import EngagementChartConfigModal from "./modals/EngagementChartConfigModal";
import VideoConvertedUserStatusModal from "./modals/VideoConvertedUserStatusModal";
import VideoArchiveSessionsModal from "./modals/VideoArchiveSessionsModal";
import Restricted from "./Restricted";

class VideoCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      showPreviewModal: false,
      showApprovalModal: false,
      showVideoApproved: false,
      showAlertModal: false,
      showThumbnailsModal: false,
      showAppropriationTimeModal: false,
      showVideoConfigModal: false,
      showVideoBotConfigModal: false,
      showRefishingModal: false,
      showDataExtractionModal: false,
      showEngagementChartConfigModal: false,
      showVideoConvertedUserStatusModal: false,
      showArchiveSessionsModal: false,
      showKey: false,
      approval: {
        labelText: "Aprovar vídeo",
        disabled: false
      },
      key: "",
      nonce: "",
      thumbSizes: {}
    };

    // preview
    this.closePreviewModal = this.closePreviewModal.bind(this);
    this.openPreviewModal = this.openPreviewModal.bind(this);
    this.previewVideo = this.previewVideo.bind(this);
    this.getSessionId = this.getSessionId.bind(this);
    this.loadSession = this.loadSession.bind(this);

    // approval
    this.closeApprovalModal = this.closeApprovalModal.bind(this);
    this.openApprovalModal = this.openApprovalModal.bind(this);
    this.getNonce = this.getNonce.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitApproval = this.submitApproval.bind(this);
    this.download = this.download.bind(this);

    // alert
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.openAlertModal = this.openAlertModal.bind(this);
    this.submitAlertForm = this.submitAlertForm.bind(this);

    // progress bar
    this.toggleProgressBar = this.toggleProgressBar.bind(this);

    // destinatarios popover creator
    this.destinatariosPopover = this.destinatariosPopover.bind(this);

    // thumbnails modal
    this.closeThumbnailsModal = this.closeThumbnailsModal.bind(this);
    this.openThumbnailsModal = this.openThumbnailsModal.bind(this);

    // appropriationTime modal
    this.openAppropriationTimeModal = this.openAppropriationTimeModal.bind(this);
    this.closeAppropriationTimeModal = this.closeAppropriationTimeModal.bind(this);

    // videoconfig modal
    this.openVideoConfigModal = this.openVideoConfigModal.bind(this);
    this.closeVideoConfigModal = this.closeVideoConfigModal.bind(this);

    // videobotconfig modal
    this.openVideoBotConfigModal = this.openVideoBotConfigModal.bind(this);
    this.closeVideoBotConfigModal = this.closeVideoBotConfigModal.bind(this);

    // Refishing Modal
    this.openRefishingModal = this.openRefishingModal.bind(this);
    this.closeRefishingModal = this.closeRefishingModal.bind(this);

    // Data Extraction Modal
    this.openDataExtractionModal = this.openDataExtractionModal.bind(this);
    this.closeDataExtractionModal = this.closeDataExtractionModal.bind(this);

    // Open & Close Modals
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    // videobotconfig modal
    this.openArchiveSessionsModal = this.openArchiveSessionsModal.bind(this);
    this.closeArchiveSessionsModal = this.closeArchiveSessionsModal.bind(this);
  }

  openArchiveSessionsModal() {
    this.setState({ showArchiveSessionsModal: true });
  }
  closeArchiveSessionsModal() {
    this.setState({ showArchiveSessionsModal: false });
  }

  closeThumbnailsModal() {
    this.setState({
      showThumbnailsModal: false
    });
  }
  openThumbnailsModal() {
    this.setState({
      showThumbnailsModal: true
    });
  }
  openAppropriationTimeModal() {
    this.setState({
      showAppropriationTimeModal: true
    });
  }
  closeAppropriationTimeModal() {
    this.setState({
      showAppropriationTimeModal: false
    });
  }
  openPreviewModal() {
    this.setState({ showPreviewModal: true });
  }
  closePreviewModal() {
    this.setState({ showPreviewModal: false });
  }
  openVideoConfigModal() {
    this.setState({ showVideoConfigModal: true });
  }
  closeVideoConfigModal() {
    this.setState({ showVideoConfigModal: false });
  }
  openVideoBotConfigModal() {
    this.setState({ showVideoBotConfigModal: true });
  }
  closeVideoBotConfigModal() {
    this.setState({ showVideoBotConfigModal: false });
  }
  openRefishingModal() {
    this.setState({ showRefishingModal: true });
  }
  closeRefishingModal() {
    this.setState({ showRefishingModal: false });
  }
  openDataExtractionModal() {
    this.setState({ showDataExtractionModal: true });
  }
  closeDataExtractionModal() {
    this.setState({ showDataExtractionModal: false });
  }
  openModal(modal) {
    let key = `show${modal}`;
    this.setState({
      [key]: true
    });
  }
  closeModal(modal) {
    let key = `show${modal}`;
    this.setState({
      [key]: false
    });
  }
  previewVideo(e, video) {
    e.preventDefault();

    this.getSessionId(video).then(response => {
      let sessionId = response.data.id;
      this.loadSession(video, sessionId);
    });
  }
  getSessionId(video) {
    let payload = {
      campaign_id: video.campaign_id,
      user_id: "11998648454", // telefone de uchoa (?)
      video_id: video.id,
      user_name: "CRISTIANE",
      preview: true,

      // vídeo IR, eu acho.
      min_value: 10000,
      max_value: 15000,

      // video Leve Mais
      original_proposal_value: 400000,
      original_split_value: 149844,
      original_splits: 4,
      new_proposal_value: 676208, // R$6.762,08
      new_split_value: 149844, // R$ 1.498,44
      new_splits: 8,

      // video Oferta Rápida
      proposal_value: 50000,
      split_value: 5000,
      proposal_splits: 10
    };

    let token = getAuthToken();
    return axios({
      method: "post",
      url: `${config.url}/recomendations/preview?t=${token}`,
      data: {
        session: payload
      }
    });
  }
  loadSession(video, sessionId) {
    let token = getAuthToken();
    let src = `${config.url}/recomendations/preview/${sessionId}/?t=${token}`;

    let iframe = document.createElement("iframe");
    iframe.id = "player-iframe";
    iframe.src = src;
    iframe.width = 560;
    iframe.height = 314;
    iframe.allowFullscreen = true;
    iframe.frameBorder = 0;

    this.openPreviewModal();
    let container = document.getElementById("video-" + video.id);
    container.innerHTML = "";
    container.appendChild(iframe);
  }
  openApprovalModal() {
    this.setState({
      showApprovalModal: true
    });
    this.getNonce().then(res => {
      let nonce = res.data.nonce;
      this.setState({
        nonce
      });
    });
  }
  closeApprovalModal() {
    this.setState({ showApprovalModal: false });
  }
  getNonce() {
    let { video } = this.props;
    let campaignId = video.campaign_id;
    let videoId = video.id;
    let path = `${config.url}/campaigns/${campaignId}/videos/${videoId}/approval/new`;

    return axios({
      method: "get",
      url: path,
      headers: { "X-User-Token": getAuthToken() }
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      approval: {
        labelText: "Carregando...",
        disabled: true
      }
    });
    if (this.state.nonce === "") {
      console.error("invalid nonce");
      rollbar.error("Usuário tentou aprovas video mas nonce está vazio.");
      this.setState({
        errorMessage: "Ocorreu um erro. Tente novamente mais tarde."
      });
      return false;
    }
    let email = this.email.value;
    let password = this.password.value;
    let nonce = this.state.nonce;
    let { video, updateVideo, user } = this.props;
    let data = {
      user: {
        email,
        password
      },
      nonce
    };
    this.submitApproval(data)
      .then(res => {
        this.setState({
          key: res.data,
          showVideoApproved: true,
          approval: {
            labelText: "Video aprovado",
            disabled: true
          }
        });
        let updatedVideo = {
          ...video,
          approved: true,
          approved_at: new Date(),
          approved_by: user.name
        };
        updateVideo(video.campaign_id, updatedVideo);
      })
      .catch(err => {
        rollbar.error("Erro ao aprovar video.", err);
        this.setState({
          errorMessage: "Ocorreu um erro. Tente novamente mais tarde.",
          approval: {
            labelText: "Aprovar vídeo",
            disabled: false
          }
        });
      });
  }
  submitApproval(data) {
    let { video } = this.props;
    let campaignId = video.campaign_id;
    let videoId = video.id;
    let path = `${config.url}/campaigns/${campaignId}/videos/${videoId}/approval/`;
    return axios({
      method: "post",
      url: path,
      data: { video_approval: data },
      headers: { "X-User-Token": getAuthToken() }
    });
  }
  download() {
    let { video } = this.props;
    let token = getAuthToken();
    let path = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/approval?x_user_token=${token}`;
    window.location = path;
  }
  openAlertModal() {
    this.setState({
      showAlertModal: true
    });
  }
  closeAlertModal() {
    this.setState({
      showAlertModal: false
    });
  }
  submitAlertForm(alert) {
    let { video, addAlertToVideo } = this.props;
    let recipients = alert.recipients.split(",").reduce((initial, recipient) => {
      let trimmedRecipient = recipient.trim();
      if (trimmedRecipient !== "") {
        initial.push(trimmedRecipient);
      }
      return initial;
    }, []);
    alert = {
      ...alert,
      recipients,
      done: false
    };
    let updatedVideo = {
      ...video,
      play_alerts: [...video.play_alerts, alert]
    };
    addAlertToVideo(video.campaign_id, updatedVideo, alert);
  }
  toggleProgressBar() {
    let { video, campaign, updateVideo } = this.props;
    if (campaign.state === "playing") {
      return;
    }
    let updatedVideo = {
      ...video,
      progressBar: !video.progressBar
    };
    updateVideo(video.campaign_id, updatedVideo);
  }
  destinatariosPopover(alert, index) {
    let recipients = [];
    if (alert.recipients) {
      recipients = alert.recipients.reduce((initial, recipient) => {
        if (recipient !== "rafael@overmediacast.com") {
          initial.push(recipient);
        }
        return initial;
      }, []);
    }
    return (
      <Popover id={`popover-trigger-hover-focus-${index}`} title="Destinatários">
        <ul>{recipients.map((recipient, index) => <li key={index}>{recipient}</li>)}</ul>
      </Popover>
    );
  }
  render() {
    const { campaign, video, user } = this.props;
    let {
      errorMessage,
      showVideoApproved,
      showApprovalModal,
      showPreviewModal,
      showAlertModal,
      showThumbnailsModal,
      showAppropriationTimeModal,
      showVideoConfigModal,
      showArchiveSessionsModal,
      showVideoBotConfigModal,
      showRefishingModal,
      showDataExtractionModal,
      showEngagementChartConfigModal,
      showVideoConvertedUserStatusModal,
      showKey,
      approval
    } = this.state;
    return (
      <div>
        <div className="video-card col-md-6">
          <div className="video-card__thumb">
            <img src={video.thumbnail_url} alt={video.title} />
            <Restricted accepted={["itau", "overmedia", "admin"]}>
              {this.props.clientId !== "5a284060c493f614515b7ab4" &&
                video.ready && (
                  <button className="video-card__thumb-button" onClick={this.openThumbnailsModal}>
                    <Glyphicon glyph="cog" />
                  </button>
                )}
            </Restricted>
          </div>
          <div className="video-card__content">
            <h3 className="video-card__title clearfix">
              <VideoTitleEditable video={video} />
              <Restricted accepted={["itau", "overmedia", "admin"]}>
                <VideoStatusLabel status={video.status} />
              </Restricted>
            </h3>
            <p>
              <span className="text-muted">campaign_id </span>
              <code>{video.campaign_id}</code>
            </p>
            <p>
              <span className="text-muted">video_id </span>
              <code>{video.id}</code>
            </p>
            {(this.props.clientId !== "5a284060c493f614515b7ab4" || video.player_type !== "brand_channel") && (
              <div className="video-card__buttons">
                <Restricted rejected={["itau"]}>
                  <Link to={`/campaigns/${campaign.id}/stats`}>
                    <button className="btn btn-sm btn-primary">ver estatísticas</button>
                  </Link>
                </Restricted>

                <Restricted accepted={["itau", "overmedia", "admin"]}>
                  {video.ready && (
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={e => {
                        this.previewVideo(e, video);
                      }}
                    >
                      Preview
                    </button>
                  )}
                </Restricted>
                <Restricted accepted={["itau", "overmedia", "admin"]}>
                  {video.ready &&
                    !video.approved && (
                      <button className="btn btn-sm btn-success" onClick={this.openApprovalModal}>
                        Aprovar
                      </button>
                    )}
                  {video.ready && <ButtonPlayPause video={video} />}
                </Restricted>

                <DropdownButton bsSize="small" title={<Glyphicon glyph="cog" />} id={`config-${video.id}`}>
                  {video.workflow && (
                    <LinkContainer to={`/campaigns/${campaign.id}/video/${video.id}/workflow`}>
                      <MenuItem>Workflow</MenuItem>
                    </LinkContainer>
                  )}

                  {/* <MenuItem onClick={this.openAlertModal}>Configurar alertas</MenuItem> */}
                  {/* <MenuItem onClick={this.toggleProgressBar} disabled={campaign.state === 'playing'}>{`${video.progressBar ? 'Desabilitar' : 'Habilitar'} barra de progresso`}</MenuItem> */}
                  <Restricted accepted={["itau", "overmedia", "admin"]}>
                    {video.ready && (
                      <MenuItem onClick={this.openAppropriationTimeModal}>Configurar tempo de apropriação</MenuItem>
                    )}
                    {video.ready && (
                      <LinkContainer to={`/campaigns/${campaign.id}/video/${video.id}/abtest`}>
                        <MenuItem>Teste A/B</MenuItem>
                      </LinkContainer>
                    )}
                  </Restricted>

                  {(this.props.accountId === "57f2c9a612f41e0003000000" ||
                    this.props.accountId === "57977d7c5622e80003000000") && (
                    <MenuItem onClick={this.openVideoConfigModal}>Configurar video</MenuItem>
                  )}

                  <LinkContainer to={`/campaigns/${campaign.id}/videos/${video.id}/mailing-viewer`}>
                    <MenuItem>Envio de Mailing</MenuItem>
                  </LinkContainer>

                  <Restricted accepted={["overmedia", "admin"]}>
                    <MenuItem divider />
                    <LinkContainer to={`/campaigns/${campaign.id}/videos/${video.id}/mailing-manager`}>
                      <MenuItem>Gerência de Mailing</MenuItem>
                    </LinkContainer>

                    <MenuItem onClick={this.openVideoBotConfigModal}>Configurar VideoBot</MenuItem>
                    <MenuItem onClick={this.openArchiveSessionsModal}>Arquivar Sessões</MenuItem>

                    <LinkContainer to={`/campaigns/${campaign.id}/video/${video.id}/brand-channel`}>
                      <MenuItem>Criar Brand Channel</MenuItem>
                    </LinkContainer>
                    <LinkContainer to={`/campaigns/${campaign.id}/video/${video.id}/sending`}>
                      <MenuItem>Geração de URLs</MenuItem>
                    </LinkContainer>
                    <LinkContainer to={`/campaigns/${campaign.id}/video/${video.id}/users-to-exclude`}>
                      <MenuItem>Users to Exclude</MenuItem>
                    </LinkContainer>
                    <MenuItem onClick={this.openRefishingModal}>Repescagem</MenuItem>
                    <MenuItem onClick={this.openDataExtractionModal}>Extração de Dados</MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.openModal("EngagementChartConfigModal");
                      }}
                    >
                      Configurar gráfico de engajamento
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.openModal("VideoConvertedUserStatusModal");
                      }}
                    >
                      Configurar usuários convertidos
                    </MenuItem>
                  </Restricted>
                </DropdownButton>
                {video.approved && (
                  <p className="mt20">
                    <small className="text-muted">
                      Video aprovado por {video.approved_by} <br />em{" "}
                      {moment(video.approved_at).format("DD/MM/YYYY [às] HH:mm")}
                    </small>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>

        <Modal show={showPreviewModal} onHide={this.closePreviewModal}>
          <Modal.Header closeButton>
            <Modal.Title>{video.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id={"video-" + video.id} />
          </Modal.Body>
        </Modal>

        <Modal show={showApprovalModal} onHide={this.closeApprovalModal}>
          <Modal.Header closeButton>
            <Modal.Title>Aprovar video {video.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={showVideoApproved ? "hidden" : ""}>
              {/* {JSON.stringify(video, null, 2)} */}
              {video.thumbnails && video.thumbnails.length > 0 && <p>Thumbnails do video:</p>}
              {video.thumbnails &&
                video.thumbnails.map((thumb, index) => (
                  <Col md={4} key={index}>
                    <div className="mt20">
                      <ApprovalThumbPreview thumb={thumb} />
                    </div>
                  </Col>
                ))}
              <p>Entre com o seu login e senha novamente para aprovar o video.</p>
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="e-mail"
                    ref={input => {
                      this.email = input;
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control"
                    type="password"
                    placeholder="password"
                    ref={input => {
                      this.password = input;
                    }}
                  />
                </div>
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary"
                    type="submit"
                    disabled={approval.disabled || !video.config}
                  >
                    {approval.labelText}
                  </button>
                  {!video.config && (
                    <p className="text-center text-danger">O video deve ser configurado antes de ser aprovado.</p>
                  )}
                </div>
              </form>
            </div>
            <div className={showVideoApproved ? "" : "hidden"}>
              <p className="text-success">Video aprovado com sucesso!</p>
              <p>
                O video está disponível para Recomendações. Anote ou baixe o certificado contendo a chave e o{" "}
                <i>fingerprint</i> do video.
              </p>
              <div className="alert alert-info">
                <p>
                  <strong>Atenção!</strong>
                </p>
                <p>
                  Essa é a <u>única</u> oportunidade de obter o certificado.
                </p>
              </div>
              <div className="btn-group btn-group-justified">
                <div className="btn-group" role="group">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      this.setState({ showKey: !showKey });
                    }}
                  >
                    Visualizar
                  </button>
                </div>
                <div className="btn-group" role="group">
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      this.download();
                    }}
                  >
                    Fazer download
                  </button>
                </div>
              </div>
              <div className={showKey ? "mt20" : "hidden mt20"}>
                <pre style={{ height: 170 }}>
                  <code>{JSON.stringify(this.state.key, null, 4)}</code>
                </pre>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showAlertModal} onHide={this.closeAlertModal}>
          <Modal.Header closeButton>
            <Modal.Title>Alertas para o video {video.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="clearfix">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Nome do alerta</th>
                  <th>Quantidade de plays</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {video.play_alerts &&
                  video.play_alerts.map((alert, index) => (
                    <tr key={index}>
                      <td>{alert.name}</td>
                      <td>{alert.value}</td>
                      <td>{alert.done ? <span className="text-success">ok</span> : ""}</td>
                      <td className="text-right">
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          placement="right"
                          overlay={this.destinatariosPopover(alert, index)}
                        >
                          <button className="btn btn-link">ver destinatários</button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                {video.play_alerts &&
                  video.play_alerts.length === 0 && (
                    <tr>
                      <td colSpan="3">Você ainda não possui nenhum alerta para este video.</td>
                    </tr>
                  )}
              </tbody>
            </table>
            {video.play_alerts && (
              <p className="text-right">
                <small>Número de alertas: {video.play_alerts.length} / 3</small>
              </p>
            )}
            {video.play_alerts &&
              video.play_alerts.length < 3 && (
                <div>
                  <hr />
                  <h3>Adicionar novo alerta</h3>
                  <div className="mt20">
                    <NewAlertForm onSubmit={this.submitAlertForm} initialValues={{ recipients: `${user.email}, ` }} />
                  </div>
                </div>
              )}
          </Modal.Body>
        </Modal>

        <ThumbnailsModal show={showThumbnailsModal} close={this.closeThumbnailsModal} video={video} />

        <AppropriationTimeModal
          show={showAppropriationTimeModal}
          close={this.closeAppropriationTimeModal}
          video={video}
        />

        <VideoConfigModal show={showVideoConfigModal} close={this.closeVideoConfigModal} video={video} />
        <VideoArchiveSessionsModal
          show={showArchiveSessionsModal}
          close={this.closeArchiveSessionsModal}
          video={video}
        />

        <VideoBotConfigModal show={showVideoBotConfigModal} close={this.closeVideoBotConfigModal} video={video} />

        <RefishingModal show={showRefishingModal} close={this.closeRefishingModal} video={video} />

        <DataExtractionModal show={showDataExtractionModal} close={this.closeDataExtractionModal} video={video} />

        <EngagementChartConfigModal
          show={showEngagementChartConfigModal}
          close={() => {
            this.closeModal("EngagementChartConfigModal");
          }}
          video={video}
        />

        <VideoConvertedUserStatusModal
          show={showVideoConvertedUserStatusModal}
          close={() => {
            this.closeModal("VideoConvertedUserStatusModal");
          }}
          video={video}
        />
      </div>
    );
  }
}

VideoCard.propTypes = {
  campaign: object,
  user: object,
  video: object,
  updateVideo: func,
  addAlertToVideo: func,
  accountId: string,
  clientId: string
};

const mapStateToProps = state => {
  return {
    user: state.app.user,
    accountId: state.app.activeAccount._id,
    clientId: state.app.user.client_id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateVideo: (campaignId, video) => {
      dispatch(updateVideo(campaignId, video));
    },
    addAlertToVideo: (campaignId, video, alert) => {
      dispatch(addAlertToVideo(campaignId, video, alert));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoCard);



// WEBPACK FOOTER //
// ./src/components/VideoCard.js